const NorthKoreaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112060)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0004 0C13.9386 0 8.50709 2.69719 4.83936 6.95648H35.1613C31.4937 2.69719 26.0622 0 20.0004 0Z"
        fill="#0052B4"
      />
      <path
        d="M35.1614 33.043H4.83936C8.50709 37.3023 13.9386 39.9995 20.0004 39.9995C26.0622 39.9995 31.4937 37.3023 35.1614 33.043Z"
        fill="#0052B4"
      />
      <path
        d="M37.0645 9.56543H2.93547C1.07383 12.6033 0 16.1762 0 20.0002C0 23.8242 1.07383 27.3971 2.93547 30.435H37.0645C38.9262 27.3971 40 23.8242 40 20.0002C40 16.1762 38.9262 12.6033 37.0645 9.56543Z"
        fill="#D80027"
      />
      <path
        d="M12.304 27.6959C16.5542 27.6959 19.9996 24.2505 19.9996 20.0003C19.9996 15.7501 16.5542 12.3047 12.304 12.3047C8.05385 12.3047 4.6084 15.7501 4.6084 20.0003C4.6084 24.2505 8.05385 27.6959 12.304 27.6959Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.3042 12.3047L14.0308 17.6188H19.6275L15.0981 20.9034L16.8382 26.2334L12.3042 22.9332L7.77697 26.2272L9.51025 20.9034L4.98486 17.6188H10.5774L12.3042 12.3047Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112060">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NorthKoreaSvg;
